export default {
    data: () => {
        return {
            id: 0,
            isList: true,
        }
    },
    watch: {
        $route(newRoute) {
            this.checkRoute(newRoute)
        },
    },
    mounted() {
        this.checkRoute(this.$router.currentRoute)
    },
    methods: {      
        checkRoute(newRoute) {
            this.loaded = false
            console.log('route newRoute', newRoute)
            let {
                params: { id },
            } = newRoute
            id = parseInt(id)
            if (id || id === 0) {
                this.id = id
                this.isList = false
                this.loaded = true
            } else {
                this.isList = true
            }
        },
    },
}
